<template>
  <div
    class="flexbox"
    data-name="flexbox"
    :title="editor ? tips[0] : tips[1]"
    :class="{editor}"
    :style="[{ left: lt + 'px', top: tp + 'px', width: w + 'px', height: h + 'px' },border ? borStyle : null, priority > 0 ? {zIndex: priority} : null]"
    @mousedown.prevent="pressdown"
    @dragover.prevent
    @drop.stop="dropModal"
  >
    <i :class="{flexc: border}" class="tot"></i>
    <i :class="{flexc: border}" class="tob" data-name="dragline-b" title="纵向缩放"></i>
    <i :class="{flexc: border}" class="tol"></i>
    <i :class="{flexc: border}" class="tor" data-name="dragline-r" title="横向缩放"></i>
    <div v-show="prior" class="priority-box" data-name="flexbox" @mousedown.stop="pressdown">
      <el-button @click="addPriority" title="升1层" type="primary" icon="el-icon-plus" circle></el-button>
      <span style="cursor: default;" title="层级">{{priority}}</span>
      <el-button @click="minusPriority" title="降1层" type="primary" icon="el-icon-minus" circle></el-button>
    </div>
    <div class="del-box" v-show="isDel">
      <el-button @click="delFlex('content')" type="primary" size="mini" title="清除框内所有" icon="el-icon-refresh-left" round>重置内容</el-button>
      <el-button @click="delFlex('modal')" type="danger" size="mini" title="删除边框及内部所有" icon="el-icon-delete" round>全部删除</el-button>
    </div>
    <div class="modal-box" v-if="modalName">
      <i class="el-icon-lock my-lock" v-show="!editor" @click="editor = true" title="点击解锁"></i>
      <i class="el-icon-unlock my-lock" v-show="editor" @click="editor = false" title="点击锁定"></i>
      <component :is="disModal" :name="modal" :time="time" :wid="w" :hih="h"></component>
      <div v-show="editor" data-name="flexbox" @mousedown.self="pressdown" class="modal-wrap"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Message } from "element-ui";
Vue.component(Message.name,Message);
import { throttle } from "../utils/tools";
export default {
  name: "flex-box",
  props: ['id','axis','widh','border','isDel','prior','cpts','modal','coms','obj'],
  data() {
    return {
      time: null,
      editor: true,
      tips: ['已解锁','已锁定'],
      pressDown: false,
      priority: 0,
      lt: 50,
      tp: 50,
      w: 150,
      h: 100,
      lt_0: 50,
      tp_0: 50,
      w_0: 150,
      h_0: 100,
      s_0: {
        x: 0,
        y: 0,
        t: undefined
      },
      borStyle: {},
      disModal: null,
      modalName: null,
      modalId: null
    };
  },
  watch: {
    axis: {
      handler(newval) {
        const [x,y,s] = newval;
        if(s) {
          this.pressDown = false;
          this.lt_0 = this.lt;
          this.tp_0 = this.tp;
          this.w_0 = this.w;
          this.h_0 = this.h;
        }
        else if(this.editor && this.pressDown) {
          this.editBox(x,y);
        }
      },
      deep: true
    }
  },
  created() {
    this.$nextTick(()=> {
      if(this.obj.w_p) {
        const { priority,lt_p,tp_p,w_p,h_p,modalName,modalId } = this.obj;
        this.priority = priority;
        this.w = this.w_0 = this.widh.w * w_p;
        this.h = this.h_0 = this.widh.h * h_p;
        const _lt = this.widh.w * lt_p,_tp = this.widh.h * tp_p;
        this.lt = this.lt_0 = _lt < 0 ? 0 : (_lt > this.widh.w - this.w ? this.widh.w - this.w : _lt);
        this.tp = this.tp_0 = _tp < 0 ? 0 : (_tp > this.widh.h - this.h ? this.widh.h - this.h : _tp);
        this.modalName = modalName;
        this.modalId = modalId;
        this.disModal = this.coms[modalName] ? this.coms[modalName] : modalName;
        this.borStyle = {
          border: '2px solid transparent'
        };
        this.tips = ['',''];
        this.editor = false
      } else {
        this.borStyle = {
          border: '2px solid #9f9898'
        };
      }
    })
  },
  mounted() {
    this.reSet = throttle(() => {
      this.time = Date.now();
    },300,this);
  },
  methods: {
    editToggle() {
      // if(this.obj.w_p) {
      //   return;
      // }
      this.editor = !this.editor;
    },
    pickData() {
      const lt_p = this.lt / this.widh.w;
      const tp_p = this.tp / this.widh.h;
      const w_p = this.w / this.widh.w;
      const h_p = this.h / this.widh.h;
      const modal = {
        id: this.id,
        priority: this.priority,
        lt_p,
        tp_p,
        w_p,
        h_p,
        modalName: this.modalName,
        modalId: this.modalId
      };
      return modal;
    },
    pressdown(e) {
      if (!this.editor) {
        return;
      }
      const type = e.target.dataset.name; // flexbox: 母盒；dragline: 拖拉线；undefined: 非拖拉线
      if (!type) {
        return;
      }
      this.pressDown = true;
      this.s_0 = {
        // 起始坐标、类型
        x: e.clientX,
        y: e.clientY,
        t: type,
      };
    },
    editBox(x,y) {
      const osx = x - this.s_0.x; // 水平偏移量
      const osy = y - this.s_0.y; // 垂直偏移量

      if (this.s_0.t === "flexbox") {
        // 母盒
        const _lt_0 = this.lt_0 + osx;
        const _tp_0 = this.tp_0 + osy;
        this.lt = _lt_0 < 0 ? 0 : (_lt_0 > this.widh.w - this.w ? this.widh.w - this.w : _lt_0);
        this.tp = _tp_0 < 0 ? 0 : (_tp_0 > this.widh.h - this.h ? this.widh.h - this.h : _tp_0);
      } else if (this.s_0.t === "dragline-b") {
        // 下拉
        this.reSet();
        const _h = this.h_0 + osy;
        this.tp = Math.min(this.tp_0, this.tp_0 + _h);
        this.h = Math.abs(_h) > this.widh.h - this.tp ? this.widh.h - this.tp : Math.abs(_h);
      } else if (this.s_0.t === "dragline-r") {
        // 右拉
        this.reSet();
        const _w = this.w_0 + osx;
        this.lt = Math.min(this.lt_0, this.lt_0 + _w);
        this.w = Math.abs(_w) > this.widh.w - this.lt ? this.widh.w - this.lt : Math.abs(_w);
      }
    },
    delFlex(type) {
      if(type === 'content') {
        this.disModal = null;
        this.modalName = null;
        this.modalId = null;
        return;
      }
      this.$emit('clear',this.id)
    },
    dropModal(e) {
      if(e.target.className === 'modal-wrap') {
        Message({
            message: '已存在模型!',
            type: "warning",
            duration: 3000
        });
        return;
      }
      if(this.isDel) {
        Message({
            message: '删除状态禁止编辑!',
            type: "warning",
            duration: 3000
        });
        return;
      }
      if(!this.editor) {
        Message({
            message: '非编辑状态!',
            type: "warning",
            duration: 3000
        });
        return;
      }
      for(let i = 0,len = this.cpts.length;i < len;i++) {
        if(this.cpts[i].id === Number(this.modal.split('_')[1])) {
          this.disModal = this.coms[this.cpts[i].component] ? this.coms[this.cpts[i].component] : this.cpts[i].component;
          this.modalName = this.cpts[i].component;
          this.modalId = this.cpts[i].id;
          break;
        }
      }
    },
    addPriority() {
      const value = this.priority + 1;
      this.priority = value > 100 ? 100 : value;
    },
    minusPriority() {
      const value = this.priority - 1;
      this.priority = value < 0 ? 0 : value;
    }
  },
};
</script>

<style lang="scss" scoped>
.flexbox {
  box-sizing: border-box;
  position: absolute;
  cursor: default;

  .flexc {
    position: absolute;
    z-index: 9997;
    // border: 1px solid #9f9898;

    &.tot {
      top: -2px;
      left: -1px;
      width: 100%;
    }
    &.tob {
      bottom: -2px;
      left: -1px;
      width: 100%;
    }
    &.tol {
      left: -2px;
      top: -1px;
      height: 100%;
    }
    &.tor {
      right: -2px;
      top: -1px;
      height: 100%;
    }
  }
  &.editor {
    border: 2px solid #00a4ff;
    cursor: move;
    .flexc {
      border: 1px solid #00a4ff;

      &.tob {
        cursor: s-resize;
      }
      &.tor {
        cursor: e-resize;
      }
    }
  }
  .priority-box {
    position: absolute;
    width: 100%;
    height: 100%;
    font-size: 25px;
    background-color: #0003;
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 9999;
  }
  .del-box {
    width: 70%;
    height: 100%;
    padding: 0 15%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 9999;
    position: absolute;
    background-color: #0003;
  }
  .modal-box {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 2px 2px 0;
    position: relative;

    .my-lock {
      padding: 3px;
      font-size: 20px;
      color: #00000029;
      position: absolute;
      left: 0;
      top: 50%;
      z-index: 10000;
      transform: translateY(-13px);
      transition: all .3s linear;
      cursor: pointer;

      &:hover {
        color: #00a4ff;
      }
    }

    .modal-wrap {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 9998;
    }
  }
}
</style>
